import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TvaService {
  constructor(private http: HttpClient) { }

  checkTva(tva: string): Observable<any> {
    if (!tva || tva.trim().length === 0) {
      return of({ isValid: false, message: 'Code TVA requis' });
    }

    // Met les 2 premiers caractères en majuscules si c'est un préfixe pays (lettres)
    // puis ajoute BE si le numéro commence directement par un chiffre (numéro BE sans préfixe)
    const trimmed = tva.trim();
    const normalized = /^[a-zA-Z]{2}/.test(trimmed)
      ? trimmed.slice(0, 2).toUpperCase() + trimmed.slice(2)  // ex: fr12345 → FR12345, be0214 → BE0214
      : /^\d/.test(trimmed)
        ? 'BE' + trimmed  // ex: 0214596464  → BE0214596464 
        : trimmed;

    const EU_VAT_REGEX = /^(ATU\d{8}|BE[01]\d{9}|BG\d{9,10}|CY\d{8}[A-Z]|CZ\d{8,10}|DE\d{9}|DK\d{8}|EE\d{9}|EL\d{9}|ES[A-Z0-9]\d{7}[A-Z0-9]|FI\d{8}|FR[A-HJ-NP-Z0-9]{2}\d{9}|HR\d{11}|HU\d{8}|IE\d[A-Z0-9+*]\d{5}[A-Z]{1,2}|IT\d{11}|LT(\d{9}|\d{12})|LU\d{8}|LV\d{11}|MT\d{8}|NL\d{9}B\d{2}|PL\d{10}|PT\d{9}|RO\d{2,10}|SE\d{12}|SI\d{8}|SK\d{10})$/;

    if (!EU_VAT_REGEX.test(normalized)) {
      return of({ isValid: false, message: 'Format de TVA invalide' });
    }

    const countryCode = normalized.slice(0, 2);
    const number = normalized.slice(2); // ex: 1020618855

    return this.http.get<any>(`${environment.apiUrl}/api/companies/tva/check/${countryCode}/${number}`);
  }
}
